import { render, staticRenderFns } from "./skuSetting.vue?vue&type=template&id=464310ca&scoped=true"
import script from "./skuSetting.vue?vue&type=script&lang=js"
export * from "./skuSetting.vue?vue&type=script&lang=js"
import style0 from "./skuSetting.vue?vue&type=style&index=0&id=464310ca&prod&lang=scss&scoped=true"
import style1 from "./skuSetting.vue?vue&type=style&index=1&id=464310ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464310ca",
  null
  
)

export default component.exports